
<div class="map-container">
    <div class="map-frame">
      <div id="map">
      </div>
    </div>
</div>

 <div #popup>
  <div *ngIf="showPopup" style="width: 20em; height: 40em; margin: 0 auto" >
    <div class="row" >
      <div class="col-12" style="width: 20em; height: 20em; margin: 0 auto" *ngIf="paramsPopup.fileRoots.length>0">
        <carousel >
          <slide *ngFor="let image of paramsPopup.fileRoots">
            <img [src]="getUrlImage(image.fileRoot)"alt="image.fileRoot" style="width: 20em; height: 20em; margin: 0 auto">
          </slide>
        </carousel>
      </div>
      <div *ngIf="paramsPopup.fileRoots.length==0" style="width: 20em; height: 20em; margin: 0 auto">
        <img src="assets/images/image-not-found.png" alt="Not found" style="width: 20em; height: 15em; margin: 0 auto">
      </div>
      <div class="col-12" style="cursor:pointer" >
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2" *ngIf="paramsPopup.provinceDTO">
          <strong><span>{{ 'FARM.FARM_IN' | translate }}: </span></strong>
          <span>{{paramsPopup.townHallDTO?.townHallName}}, {{paramsPopup.provinceDTO?.provinceName}}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2" *ngIf="paramsPopup.municipalityDTO">
          <strong><span>{{ 'FARM.FARM_IN' | translate }}: </span></strong>
          <span>{{paramsPopup.districtDTO?.districtName}}, {{paramsPopup.municipalityDTO?.municipalityName}}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
          <strong><span>{{ 'FARM.DESITE_TO.DESITE_TO' | translate }}: </span></strong>
            <span *ngFor="let exp of paramsPopup.exploitations" >{{'FARM.DESITE_TO.TYPE.' + exp | uppercase | translate }}  </span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
          <strong><span>{{ 'FARM.OBJECTIVES_TO.OBJECTIVES_TO' | translate }}: </span></strong>
          <span *ngFor="let obj of paramsPopup.objectives" >{{'FARM.OBJECTIVES_TO.TYPE.' + obj | uppercase | translate }}  </span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
          <strong><span>{{'FARM.AREA' | translate}}: </span></strong>
          <span>{{paramsPopup.area}}{{'FARM.HECTARES' | translate}}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2">
          <strong><span>{{'REGISTER.MOBILE_NUMBER' | translate}}: </span></strong>
          <span>{{paramsPopup.numberPhone}}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2" style=" height: 4em;">
          <strong><span>{{'FARM.INFO_FARM' | translate}}: </span></strong>
          <span >{{(paramsPopup.information.length>64) ? (paramsPopup.information | slice:0:64)+'...':(paramsPopup.information) }}</span>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 mb-2" style="float: none; align-content:center; text-align: center;" >
          <button mat-button (click)="onClickToFarm($event, paramsPopup.id)">{{'FARM.DETAILS_FARMS' | translate}}</button>
        </div> 
      </div>
    </div>

  </div>
</div> 